import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Fieldset } from "primereact/fieldset";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";
import { classNames } from "primereact/utils";
import { timesheetApi, Util } from "../../../services";
import { toast } from "react-toastify";
import { InputTextarea } from "primereact/inputtextarea";

function TimesheetActivityForm({ onClose, projectList, timesheetId, activityListData, totaltimesheethours }) {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [selectedHour, setSelectedHour] = useState("");
  const [selectedDescription, setSelectedDescription] = useState("");
  const [selectedJiraTaskId, setSelectedJiraTaskId] = useState("");
  const [errorLog, SetErrorLog] = useState(false);

  const validateError = () => {
    if (selectedCategory === "" || selectedActivity === "" || selectedHour === "") {
      SetErrorLog(true);
      return true;
    }
  };
  const onCategoryChange = (e) => {
    setSelectedCategory(e.value);
  };
  const onActivityChange = (e) => {
    setSelectedActivity(e.value);
  };
  const onHourChange = (e) => {
    setSelectedHour(e.target.value);
  };
  const onDescriptionChange = (e) => {
    setSelectedDescription(e.target.value);
  };
  const onJiraTaskIdChange = (e) => {
    setSelectedJiraTaskId(e.target.value);
  }
  const onCloseMethod = () => {
    onClose();
  };

  const saveTimesheetActivity = (index, e) => {
    const error = validateError();
    if (error) {
    } else {
      let activityIsBillable = e.Project.activities.find((item) => {
        return item.id === selectedActivity.id && e.projectId;
      });
      const addedActivityData = {
        timesheetId: timesheetId,
        projectId: e.projectId,
        categoryId: selectedCategory.id,
        activityId: selectedActivity.id,
        isBillable: activityIsBillable.isBillable,
        hours: parseFloat(selectedHour),
        jiraTaskId: selectedJiraTaskId,
        description: selectedDescription,
      };
      let activityList = activityListData.filter((el) => el.id === timesheetId);
      const isDuplicate = activityList[0].timesheetProjects.filter((x) => {
        return (x.activityId === addedActivityData.activityId && x.categoryId === addedActivityData.categoryId);
      });
      if ((addedActivityData.hours + totaltimesheethours) > 24) {
        toast.error("You cannot add more than 24 hours");
      }
      if (isDuplicate.length > 0) {
        toast.error("You cannot add duplicate timesheet activity!");
      } else {
        try {
          timesheetApi.saveTimesheetActivityData(addedActivityData).then(
            (resp) => {
              if (resp.status === 201) {
                let activityList = activityListData.filter(
                  (el) => el.id === timesheetId
                );
                let totalHrs = activityList[0].timesheetProjects.reduce(
                  (acc, curr) => acc + parseFloat(curr.hours), 0
                );
                if (totalHrs + parseFloat(selectedHour) <= 24) {
                  let param = {
                    id: timesheetId,
                    totalHours: totalHrs + parseFloat(selectedHour),
                  };
                  try {
                    timesheetApi.updateTimesheet(param).then(
                      (resp) => {
                        if (resp) {
                          toast.info("Activity added successfully...");
                          onCloseMethod();
                        }
                      },
                      (err) => {
                        toast.error("Unable to create timesheet activity...");
                      }
                    );
                  } catch (error) {
                    toast.error("Unable to create timesheet activity...");
                  }
                }
              }
            },
            (resp) => {
              toast.error(resp.response.data.error);
            }
          );
        } catch (error) {
          toast.error("Unable to create timesheet activity...");
        }
      }
    }
  };

  const projectListing = projectList.map((el, i) => {
    var currentUser = JSON.parse(localStorage.getItem("user"));
    var userCatList = el.Project.categories.filter((obj) => {
      return (
        (obj.userId === currentUser.id || obj.userId === null) && obj.status === 1
      );
    });

    var userActList = el.Project.activities.filter((obj) => {
      if (selectedCategory) {
        if (selectedCategory?.code == "LH") {
          return (
            (obj.userId === currentUser.id || obj.userId === null) &&
            obj.status === 1 && obj.type === "0"
          );
        } else {
          return (
            (obj.userId === currentUser.id || obj.userId === null) &&
            obj.status === 1 && obj.type === "1"
          );
        }
      } else {
        return (
          (obj.userId === currentUser.id || obj.userId === null) &&
          obj.status === 1
        );
      }
    });

    return (
      <AccordionTab key={i}
        header={
          <React.Fragment >
            <div style={{ width: "1020px" }}>
              <div style={{ float: "left" }}>
                <span>{el.Project.title}</span>
              </div>
              <div>
                {el?.isBillable === true ? (
                  <span style={{ marginLeft: "20px", height: "18px", color: "green" }}>Billable</span>
                ) : (
                  <span style={{ marginLeft: "20px", height: "18px", color: "red" }}>Non-Billable</span>
                )}
              </div>
            </div>
          </React.Fragment>
        }
      >
        <div className="grid">
          <InputText id="timesheetProject" name="timesheetProject" type="hidden" value={el.Project.id} maxLength={16} disabled placeholder="Project" className="mt-2" />
          <div className="field col-2" style={{ width: "162px", paddingRight: "3px" }}>
            <Dropdown filter id="timesheetCategory" name="timesheetCategory" options={userCatList} optionLabel="title" placeholder="Select Category" value={selectedCategory} onChange={onCategoryChange} className={classNames({ "p-invalid": errorLog && !selectedCategory }, "mt-2")} style={{ width: "150px" }} appendTo="self" />
            {errorLog && (
              <span> {selectedCategory === null && (<div style={{ color: "red" }}>Select Category!</div>)}
              </span>
            )}
          </div>
          <div className="field col-2" style={{ width: "162px", paddingRight: "3px", paddingLeft: "7px" }}>
            <Dropdown filter id="timesheetActivity" name="timesheetActivity" itemTemplate={Util.activityItemBody} options={userActList} optionLabel="title" placeholder="Select Activity" value={selectedActivity} onChange={onActivityChange} className={classNames({ "p-invalid": errorLog && !selectedActivity }, "mt-2")} style={{ width: "150px" }} appendTo="self" />
            {errorLog && (
              <span>
                {selectedActivity === null && (
                  <div style={{ color: "red" }}>Select Activity!</div>
                )}
              </span>
            )}
          </div>
          <div className="field col-2" style={{ width: "162px", paddingRight: "3px", paddingLeft: "7px" }}>
            <InputText onKeyPress={Util.preventMinus} onPaste={Util.preventPasteChar} maxfractiondsigits={2} maxLength={5} id="timesheetHours" name="timesheetHours" type="text" value={selectedHour} onChange={onHourChange} placeholder="Hours" className={classNames({ "p-invalid": errorLog && !selectedHour }, "mt-2")} style={{ width: "150px" }} />
            {errorLog && (
              <span>
                {selectedHour === "" && (
                  <div style={{ color: "red" }}>Enter Hours!</div>
                )}
              </span>
            )}
          </div>

          <div className="field col-2 mt-2" style={{ width: "162px", paddingRight: "3px", paddingLeft: "7px" }}>
            <InputTextarea id="JiraTaskId" name="JiraTaskId" value={selectedJiraTaskId} onChange={onJiraTaskIdChange} placeholder="JIRA / Task ID" rows={1} cols={22} style={{ width: "150px" }} />
          </div>
          <div className="field col-2 mt-2" style={{ width: "162px", paddingRight: "3px", paddingLeft: "7px" }}>
            <InputTextarea id="description" name="description" value={selectedDescription} onChange={onDescriptionChange} rows={1} cols={25} placeholder="Description" style={{ width: "170px" }} />
          </div>
          <div className="field col-1 ml-2" style={{ width: "162px", paddingRight: "7px", paddingTop: "14px", paddingLeft: "28px" }}>
            <Button type="button" label="Add" icon="pi pi-check" className="p-button-rounded" onClick={(e) => saveTimesheetActivity(i, el)} />
          </div>
        </div>
      </AccordionTab>
    );
  });

  const timesheetForm = (
    <Fieldset>
      <Accordion activeIndex={0}>{projectListing}</Accordion>
    </Fieldset>
  );
  return <React.Fragment>{timesheetForm}</React.Fragment>;
}

export default TimesheetActivityForm;